import { DermloopUserRoleEnum } from '@dermloop/static-values';
import { IsArray, IsEnum, IsUUID } from 'class-validator';

export const AUDIENCE_SCOPE_KEYS = [
  'federationIds',
  'jurisdictionalGroupIds',
  'medicalUnitIds',
] as const;

export type AudienceScopeKey = (typeof AUDIENCE_SCOPE_KEYS)[number];

export type AudienceScopes = Record<AudienceScopeKey, string[]>;

export const noAudienceScopes = (): AudienceScopes =>
  Object.fromEntries(
    AUDIENCE_SCOPE_KEYS.map((key) => [key, []]),
  ) as unknown as AudienceScopes;

/**
 * Empty roles reach every role; empty scopes reach the whole platform. An
 * audience never names individual users.
 */
export interface Audience extends AudienceScopes {
  roles: DermloopUserRoleEnum[];
}

export const platformWideAudience = (): Audience => ({
  roles: [],
  ...noAudienceScopes(),
});

// Every list is required so platform-wide is always explicit; a mistyped key cannot fail open.
export class AudienceDto implements Audience {
  @IsArray()
  @IsEnum(DermloopUserRoleEnum, { each: true })
  roles: DermloopUserRoleEnum[];

  @IsArray()
  @IsUUID('all', { each: true })
  federationIds: string[];

  @IsArray()
  @IsUUID('all', { each: true })
  jurisdictionalGroupIds: string[];

  @IsArray()
  @IsUUID('all', { each: true })
  medicalUnitIds: string[];
}

export interface AudienceScopeOptionDto {
  id: string;
  name: string;
}

/** What an audience in one federation can name, for picking scopes by name. */
export interface AudienceScopeOptionsDto {
  jurisdictionalGroups: AudienceScopeOptionDto[];
  medicalUnits: AudienceScopeOptionDto[];
}
